__turbopack_context__.v({
  "chevron": "CapacityConflictOptionRow-module-scss-module__3quInG__chevron",
  "row": "CapacityConflictOptionRow-module-scss-module__3quInG__row",
  "rowDelete": "CapacityConflictOptionRow-module-scss-module__3quInG__rowDelete",
  "subtitle": "CapacityConflictOptionRow-module-scss-module__3quInG__subtitle",
  "textWrap": "CapacityConflictOptionRow-module-scss-module__3quInG__textWrap",
  "title": "CapacityConflictOptionRow-module-scss-module__3quInG__title",
});
